import React from 'react'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state/types'
import { sourceTypeNameSelector } from '@chegg-wt/core/state/createCitation/selectors'
import { updateMessagingFlagSelector } from '@chegg-wt/core/state/app/selectors'
import { Config } from '@chegg-wt/core/config'
import { CM } from '@chegg-wt/core/constants/site'
import { SubHeadingBCRest } from '../../BrandConsolidation'

import * as Styled from './styled'

interface Props {
  sourceTypeName: string
  updateMessagingFeatureEnabled: boolean
}

export const FormTitle: React.FunctionComponent<Props> = ({
  sourceTypeName,
  updateMessagingFeatureEnabled,
}) => {
  const { appName } = Config
  return (
    <Styled.FormTitleRow>
      <Styled.H1 data-test="form-title">
        {`Finalize ${sourceTypeName.toLowerCase()} details`}
      </Styled.H1>
      {(appName !== CM || updateMessagingFeatureEnabled) && <SubHeadingBCRest formPage />}
    </Styled.FormTitleRow>
  )
}

const mapStateToProps = (state: AppState) => ({
  sourceTypeName: sourceTypeNameSelector(state),
  updateMessagingFeatureEnabled: updateMessagingFlagSelector(state),
})

export default connect(mapStateToProps)(FormTitle)
